//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiFirework, mdiMaterialDesign, mdiVuetify } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiFirework,
        mdiMaterialDesign,
        mdiVuetify,
      },
    }
  },
}
